import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { RootState } from 'redux/store'
import { ShowNote } from 'data/Show'
import { createSelector } from 'reselect'
import { postShowNote } from 'api/api'
import { showError } from './globalError'

export interface ShowNotesState {
    byId: { [id: string]: ShowNote }
    allIds: string[]
    editingNote: ShowNote | null
}

export const initialState: ShowNotesState = {
    byId: {},
    allIds: [],
    editingNote: null,
}

const showNotesSlice = createSlice({
    name: 'notes',
    initialState,
    reducers: {
        notesReceived: (state, { payload = [] }: PayloadAction<ShowNote[]>) => {
            state.byId = payload.reduce((byIds, note) => ({ ...byIds, [note._id]: note }), {})
            state.allIds = payload.map(n => n._id)
        },
        noteUpserted: (state, { payload }: PayloadAction<ShowNote>) => {
            state.byId[payload._id] = payload
            state.allIds = Object.keys(state.byId)
            state.editingNote = null
        },
        editNote: (state, { payload }: PayloadAction<ShowNote>) => {
            state.editingNote = payload
        },
        stopEditing: state => {
            state.editingNote = null
        },
    },
})

const { actions, reducer } = showNotesSlice
export default reducer

export const getNotesSlice = (store: RootState) => store.showNotes

export const getNotes = createSelector(getNotesSlice, notesSlice => notesSlice.allIds.map(id => notesSlice.byId[id]))

export const getEditingNote = createSelector(getNotesSlice, notesSlice => notesSlice.editingNote)

export const { notesReceived, editNote, noteUpserted, stopEditing } = actions

export const upsertNote = (showId: string, note: ShowNote) => async dispatch => {
    try {
        const noteResponse = await postShowNote(showId, note)
        dispatch(noteUpserted(noteResponse))
    } catch (err) {
        console.error(err)
        dispatch(showError('There was an error saving your note'))
    }
}
